import React, { useState, useRef, useEffect } from "react";
import PdfBackground from "../../../card/pdfCard/pdfBackground";
import ModalSuccess from "../modalSuccess";
import ModalAlertWarning from "../modalAlertWarning";
import { MODALS } from "../../../../config/images";
const CreatePdfModal = ({ 
  isOpen, 
  onClose, 
  onCreate,
  module = "Knowus",
  selectedFile = null, 
  onFileReset 
}) => {
  const [title, setTitle] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [showModalAlertWarning, setShowModalAlertWarning] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [characterCount, setCharacterCount] = useState(0); 

  useEffect(() => {
    if (selectedFile) {
      const fileUrl = URL.createObjectURL(selectedFile);
      setPreviewUrl(fileUrl);
    }
    
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [selectedFile]);

  const handleTitleChange = (e) => {
    const input = e.target.value;
    if (input.length <= 50) {
      setTitle(input);
      setCharacterCount(input.length);
    }
  };
  
  if (!isOpen) return null;

  const handleCreate = async () => {
    if (!title.trim()) {
      setErrorMessage("Por favor, ingrese un título para el manual.");
      setShowModalAlertWarning(true);
      return;
    }

    if (title.length > 50) {
      setErrorMessage("El título no puede exceder los 50 caracteres.");
      setShowModalAlertWarning(true);
      return;
    }

    setIsLoading(true);
    
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("file", selectedFile);
      formData.append("module", module);
      
      const response = await onCreate(formData);
      
      if (response && response.message) {
        setShowModalSuccess(true);
      }
    } catch (error) {
      console.error("Error creating manual:", error);
      if (error.response && error.response.data && error.response.data.message) {
        setErrorMessage(error.response.data.message);
      } else if (error.message) {
        setErrorMessage(error.message);
      } else {
        setErrorMessage("Error al crear el manual. Por favor, intente nuevamente.");
      }
      
      setShowModalAlertWarning(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setTitle("");
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl); 
    }
    setPreviewUrl(null);
    setShowModalSuccess(false);
    setShowModalAlertWarning(false);
    onFileReset(); 
    onClose();
  };

  const handleSuccessClose = () => {
    setShowModalSuccess(false);
    handleClose();
  };

  const handleWarningClose = () => {
    setShowModalAlertWarning(false);
  };

  

  return (
    <>
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[30%] md:w-[40%] sm:w-[50%] w-[85%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4">
        <div className='flex justify-end'>
          <button
            onClick={handleClose}
            className="px-4 py-2 rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar"/>
          </button>
        </div>

        <div className="flex flex-col items-center justify-center px-6 pb-3">
          {previewUrl && (
              <div className="relative overflow-hidden drop-shadow-manual rounded-lg h-[320px] w-[230px] mb-4">
                <PdfBackground pdfFile={previewUrl} />
                <div className="absolute inset-0 bg-opacity-50 p-4 bg-[#184A7D80] rounded-lg flex justify-center items-center overflow-auto">
                  <textarea
                    value={title}
                    onChange={handleTitleChange}
                    className="bg-transparent placeholder:text-white placeholder:text-[18px] underline w-full text-[18px] text-white font-itcbold text-center outline-none resize-none"
                    rows={5}
                    placeholder="Escriba aquí *"
                    maxLength={50}
                  />
                </div>
              </div>
          )}

          <button
            onClick={handleCreate}
            disabled={isLoading || !title.trim() || !selectedFile || title.length > 50} 
            className={`p-4 font-itcbook underline text-[15px] ${
              isLoading || !title.trim() || !selectedFile || title.length > 50
                ? " text-gray-500 cursor-not-allowed"
                : "text-blue"
            }`}
          >
            {isLoading ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </div>
    </div>
      <ModalSuccess
        showModalSuccess={showModalSuccess}
        closeModalSuccess={handleSuccessClose}
        fill="green" 
        text="¡Su manual fue agregado con éxito!"
      />

      <ModalAlertWarning
        showModalAlertWarning={showModalAlertWarning}
        closeModal={handleWarningClose}
        error={errorMessage}
        accept={handleWarningClose}
      />
      </>
  );
};

export default CreatePdfModal;